import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [_vm._v("Configuración")]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v("Dimensiones y Valores Esperados"),
              ]),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { outlined: "", dense: "" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-add")]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_crear"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onEnableFilter },
                },
                [
                  _vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-off-outline"),
                      ])
                    : _vm._e(),
                  !_vm.filter_enabled
                    ? _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ])
                    : _vm._e(),
                  _vm._v(_vm._s(_vm.$t("botones.boton_filtrar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        {
          class: {
            "flex-filter": _vm.size_screen == "sm" || _vm.size_screen == "xs",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex-filter-order1", class: _vm.getClassTable },
            [
              _c(
                VCard,
                [
                  _c(
                    VTabs,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(VTab, [_vm._v("Dimensiones")]),
                      _c(
                        VTabItem,
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_dimensions,
                              items: _vm.dimensions,
                              "hide-default-footer": "",
                              "items-per-page": _vm.pagination_dimensions.limit,
                              page: _vm.pagination_dimensions.current,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination_dimensions.total =
                                  $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination_dimensions,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditDimension(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-edit"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveDimension(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-delete"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(VTab, [_vm._v("Validaciones")]),
                      _c(
                        VTabItem,
                        [
                          _c(VDataTable, {
                            staticClass: "table-inca",
                            attrs: {
                              headers: _vm.headers_expectations,
                              items: _vm.expectations,
                              "hide-default-footer": "",
                              "items-per-page":
                                _vm.pagination_expectations.limit,
                              page: _vm.pagination_expectations.current,
                            },
                            on: {
                              pagination: function ($event) {
                                _vm.pagination_expectations.total =
                                  $event.itemsLength
                              },
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.pagination_expectations,
                                  "current",
                                  $event
                                )
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.actions",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onEditExpectation(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-edit"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "btn-icon-inca",
                                        attrs: { icon: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveExpectation(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(VIcon, { attrs: { small: "" } }, [
                                          _vm._v("icon-delete"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.tab == 0
                ? _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination_dimensions },
                  })
                : _vm._e(),
              _vm.tab == 1
                ? _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination_expectations },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.filter_enabled
            ? _c(
                "div",
                {
                  staticClass: "col-md-3 col-sm-12 mb-3",
                  class: {
                    "pl-0": _vm.size_screen == "md" || _vm.size_screen == "lg",
                  },
                },
                [
                  _c(
                    VCard,
                    { staticClass: "filters-inca" },
                    [
                      _c(
                        VCardTitle,
                        {
                          staticClass: "pointer",
                          on: {
                            click: function ($event) {
                              _vm.collapse_filter = !_vm.collapse_filter
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("titles.search_filters")))]
                      ),
                      _c(
                        VCardText,
                        { staticClass: "pa-2 pt-0" },
                        [
                          _c(
                            VRow,
                            { attrs: { dense: "" } },
                            [
                              _c(
                                VCol,
                                { staticClass: "col-md-12 col-sm-6 col-12" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Valor",
                                      placeholder: "Valor",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.value,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "value", $$v)
                                      },
                                      expression: "filters.value",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-md-12 col-sm-6 col-12" },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      label: "Nombre",
                                      placeholder: "Nombre",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.filters.text,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "text", $$v)
                                      },
                                      expression: "filters.text",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                {
                                  staticClass: "text-right",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "default mr-1",
                                      attrs: { outlined: "" },
                                      on: { click: _vm.onLimpiar },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.clean")))]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "primary ",
                                      on: { click: _vm.onSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("btns.search")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_DIMENSION",
          attrs: { title: (_vm.edit ? "Actualizar" : "Crear") + " Dimensión" },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form2" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Valor"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.edit,
                              readonly: _vm.edit,
                              rules: [
                                function (v) {
                                  return !!v || "El Valor es requerido"
                                },
                              ],
                            },
                            model: {
                              value: _vm.dimension.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.dimension, "value", $$v)
                              },
                              expression: "dimension.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Nombre"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "El Nombre es requerido"
                                },
                              ],
                            },
                            model: {
                              value: _vm.dimension.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.dimension, "text", $$v)
                              },
                              expression: "dimension.text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Descripción"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "La Descripción es requerida"
                                },
                              ],
                            },
                            model: {
                              value: _vm.dimension.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.dimension, "description", $$v)
                              },
                              expression: "dimension.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.edit ? _vm.updateDimension() : _vm.createDimension()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        { ref: "DIALOG_EXPECTATION", attrs: { title: "Crear Validación" } },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form2" },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Valor"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              filled: _vm.edit,
                              readonly: _vm.edit,
                              rules: [
                                function (v) {
                                  return !!v || "El Valor es requerido"
                                },
                              ],
                            },
                            model: {
                              value: _vm.expectation.value,
                              callback: function ($$v) {
                                _vm.$set(_vm.expectation, "value", $$v)
                              },
                              expression: "expectation.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Nombre"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "El Nombre es requerido"
                                },
                              ],
                            },
                            model: {
                              value: _vm.expectation.text,
                              callback: function ($$v) {
                                _vm.$set(_vm.expectation, "text", $$v)
                              },
                              expression: "expectation.text",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Descripción"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              rules: [
                                function (v) {
                                  return !!v || "La Descripción es requerida"
                                },
                              ],
                            },
                            model: {
                              value: _vm.expectation.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.expectation, "description", $$v)
                              },
                              expression: "expectation.description",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Tipo de Valor"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              dense: "",
                              outlined: "",
                              items: _vm.type_values,
                            },
                            model: {
                              value: _vm.expectation.type_value,
                              callback: function ($$v) {
                                _vm.$set(_vm.expectation, "type_value", $$v)
                              },
                              expression: "expectation.type_value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VRow,
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [_vm._v(_vm._s("Ejemplo"))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          _c(VTextField, {
                            attrs: { dense: "", outlined: "" },
                            model: {
                              value: _vm.expectation.example,
                              callback: function ($$v) {
                                _vm.$set(_vm.expectation, "example", $$v)
                              },
                              expression: "expectation.example",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.edit
                        ? _vm.updateExpectation()
                        : _vm.createExpectation()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("botones.boton_aceptar"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_REMOVE_DIMENSION",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar la dimensión?",
        },
        on: { onConfirm: _vm.onConfirmRemoveDimension },
      }),
      _c("dialog-confirmation-component", {
        ref: "DIALOG_REMOVE_EXPECTATION",
        attrs: {
          title: "Confirmación",
          text: "¿Esta seguro de eliminar el valor esperado?",
        },
        on: { onConfirm: _vm.onConfirmRemoveExpectation },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }